import React, { useState } from "react";
import Button from "../../Button";
import { useRouter } from "next/router";
import Icon from "../../Icon";
import InputField from "../../InputField";
import GoogleLogin from "react-google-login";
import FacebookLogin from "@greatsumini/react-facebook-login";
export default function MobileRegistrationForm({
  formFields,
  onChange,
  responseSocial,
  validators,
  dispatcher,
  callback,
}) {
  const [toSecond, setToSecond] = useState(false);
  const router = useRouter();
  return (
    <div
      className={`flex flex-col   gap-y-6  mt-14 px-10 ${
        toSecond && " duration-200  transform -translate-x-full  ease-out"
      } `}
    >
      {!dispatcher ? (
        <h3 className={`text-gray3 text-center font-hkBold text-textMobile`}>
          Create your{" "}
          <span className=" text-bgActiveButton">
            {process.env.NEXT_PUBLIC_THEME === "LT" ? "LuckyTruck" : "Flexport Insurance"}
          </span>
          &nbsp;account to get started
        </h3>
      ) : (
        <h3 className={`text-gray3 text-center font-hkBold xs:text-lg sm:text-xl xl:text-4xl `}>Dispatcher Signup</h3>
      )}
      <h3 className="text-textMobile text-center font-hkMedium text-gray6 opacity-80">
        {!dispatcher
          ? "Get the best insurance quote for you in just a few minutes"
          : "Enter your personal details here"}
      </h3>
      <div className=" border-t-2 border-dividerColor opacity-50 mt-3  w-full " />
      <InputField
        width={"w-full"}
        height={"h-14"}
        placeholder="First Name"
        name={"firstName"}
        error={formFields.firstName.error}
        message={formFields.firstName.message}
        value={formFields.firstName.value}
        onInputChange={onChange}
      />
      <InputField
        width={"w-full"}
        height={"h-14"}
        placeholder="Last Name"
        name={"lastName"}
        value={formFields.lastName.value}
        message={formFields.lastName.message}
        error={formFields.lastName.error}
        onInputChange={onChange}
      />
      <InputField
        width={"w-full"}
        height={"h-14"}
        placeholder="Email"
        name={"email"}
        value={formFields.email.value}
        message={formFields.email.message}
        error={formFields.email.error}
        onInputChange={onChange}
      />
      <Button
        title="START YOUR QUOTE"
        width="w-full"
        height="h-14"
        disabled={formFields.disabled}
        onButtonClick={async () => {
          let test = await validators();
          if (!test) {
            setTimeout(() => {
              callback(true);
            }, 200);
            setToSecond(true);
          }
        }}
      />
      {!dispatcher ? (
        <div className={` flex flex-row space-x-2`}>
          <div className=" border-t-2 border-dividerColor opacity-50 mt-3 w-2/5  " />
          <h3 className="whitespace-nowrap text-sm text-center text-signUpTextColor font-interMedium">
            Or sign up with
          </h3>
          <div className=" border-t-2 border-dividerColor opacity-50 mt-3 w-2/5  " />
        </div>
      ) : null}
      {!dispatcher ? (
        <div className={` flex flex-row items-center space-x-3 justify-center mt-5`}>
          <GoogleLogin
            clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}
            render={(renderProps) => (
              <div className="bg-white rounded-lg px-6 py-3 " onClick={renderProps.onClick}>
                <Icon name="icon-google" />
              </div>
            )}
            onSuccess={responseSocial}
            onFailure={responseSocial}
            cookiePolicy={"single_host_origin"}
          />
          {/* <FacebookLogin
            appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
            fields="name,email,picture"
            render={({ onClick, logout }) => (
              <div className="bg-white rounded-lg px-6 py-3" onClick={onClick}>
                <Icon name="icon-facebook" />
              </div>
            )}
            onSuccess={responseSocial}
            onFail={responseSocial}
          /> */}
        </div>
      ) : null}
      <div
        className=" mt-2 text-center"
        onClick={() =>
          !dispatcher
            ? router.push(process.env.NEXT_PUBLIC_USER_LOGIN)
            : router.push(process.env.NEXT_PUBLIC_DISPATCHER_LOGIN)
        }
      >
        <h3 className="font-hkRegular text-sm  text-inputColor ">Already have an account?</h3>
        <h3 className="font-hkBold  text-sm text-createAcc r">LOGIN</h3>
      </div>
    </div>
  );
}
